export default __webpack_public_path__ + "static/media/ic_content_active.d513bad2.svg";